<button class="btn btn_with_icon success_large_btn" (click)="onClick()">
    <i class="ri-file-excel-2-line"></i>Export
</button>